import React, {Component} from 'react';
import cartStyles from './cart.module.scss';
import CartHandler from '../../services/cartService';
import {FaMinus, FaPlus, FaSpinner} from 'react-icons/fa';
class cartItem extends Component {

	constructor(props){
		super(props);
		const {purchased_entity, quantity, order_item_id, order_id} = this.props.product;
		const item_total_price = this.props.product.total_price.formatted;
		this.onClick = this.addItem.bind(this);
		this.onClick = this.minusItem.bind(this);
		this.state = {
			purchased_entity : purchased_entity,
			quantity : Math.floor(quantity),
			item_total_price : item_total_price,
			order_item_id: order_item_id,
			order_id: order_id,
			fetching: false
		}
	}

	async addItem(quantity, order_item_id, order_id) {

		quantity = Math.floor(quantity) + 1;
		this.setState({
			fetching : true
		})
		let response = await CartHandler.updateCartItem(quantity, order_item_id, order_id);
		let current_item = response.order_items.filter(function(order_item) {
			return (order_item.order_item_id === order_item_id)
		});
		this.setState({
			quantity: quantity,
			item_total_price: current_item[0].total_price.formatted,
			total_price: response.total_price.formatted
		})
		this.setState({
			fetching : false
		})
	 	this.props.updateTotal(this.state.total_price);
	}

	async minusItem(quantity, order_item_id, order_id) {
		if(quantity <= 1 )  return;
		quantity = Math.floor(quantity) - 1;
		this.setState({
			fetching : true
		})
		let response = await CartHandler.updateCartItem(quantity, order_item_id, order_id);
		let current_item = response.order_items.filter(function(order_item) {
			return (order_item.order_item_id === order_item_id)
		});
		this.setState({
			quantity: quantity,
			item_total_price: current_item[0].total_price.formatted,
			total_price: response.total_price.formatted
		})
		this.setState({
			fetching : false
		})
	 	this.props.updateTotal(this.state.total_price);
	}

	render() {
	 const {purchased_entity, quantity, item_total_price, order_item_id, order_id, fetching} = this.state;
		return (	
			<div className={`cart-item ${cartStyles.cart__item}`}>
				<div className={`cart-info-wrapper ${cartStyles.item__info}`}>
				<div className={`cart-item__info`}>
					<div className="cart-item_title">{purchased_entity.title}</div>
					<div className={`cart-item_sku ${cartStyles.item__sku}`}>{purchased_entity.sku}</div>
				</div>
				<div className={cartStyles.cart__input}>
		<button className={cartStyles.minus_input} onClick={() => this.minusItem(quantity, order_item_id, order_id)}> {(fetching) ? <FaSpinner/> : <FaMinus/>}</button>
						<div className="cart-item__quantity">{quantity}</div>
		<button className={cartStyles.plus_input} onClick={() => this.addItem(quantity, order_item_id, order_id)}> {(fetching) ? <FaSpinner/> : <FaPlus/>}</button>
					</div>
				<div className={`cart-item__details ${cartStyles.item__details}`}>
					<div className="cart-item__price">{item_total_price}</div>
				</div>
				</div>
			</div>
		)
    }
};

export default cartItem;